import { Tooltip } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { User, Team } from 'api/models';
import { DateFromTo } from 'components/atoms/date-from-to';
import { DueDate } from 'components/atoms/due-date';
import { SquadAvatarList } from 'components/atoms/squad-avatar-list';

const StyledDueDate = styled(DueDate)`
  margin-left: var(--spacing-03);
`;

export const FooterAssigneeWithDate = ({ task }) => {
  return (
    <>
      {task.assignee && (
        <SquadAvatarList
          size="small"
          squad={task.assignee as { users: User[]; teams: Team[] }}
          maxCount={1}
        />
      )}
      {task.dueDate && (
        <Tooltip
          title={
            <DateFromTo
              from={task.startDate ? moment(task.startDate) : null}
              to={task.dueDate ? moment(task.dueDate) : null}
            />
          }
        >
          <StyledDueDate
            timestamp={moment(task.dueDate)}
            completed={Boolean(task.completedAt)}
          />
        </Tooltip>
      )}
    </>
  );
};
